'use client';
import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { Icon as c } from "@tameeni/icons";
import { Button as i } from "@tameeni/ui";
import { cn as n } from "@tameeni/shared-logic";
function p({
  title: l,
  description: o,
  btnLabel: a,
  image: s,
  imageClassName: t
}) {
  return /* @__PURE__ */ e("div", { className: "group min-h-[17.875rem] overflow-hidden flex flex-col gap-4 justify-between rounded-lg transition-all duration-200 h-full border hover:border-blue-500", children: /* @__PURE__ */ r("div", { className: "h-full flex flex-col gap-2 grow pb-0", children: [
    /* @__PURE__ */ r("div", { className: "p-4 flex flex-col gap-2", children: [
      /* @__PURE__ */ r("div", { className: "space-y-2 grow", children: [
        /* @__PURE__ */ e("h2", { className: "text-t1 font-bold", children: l }),
        /* @__PURE__ */ e("p", { className: "text-b2 text-slate-600", children: o })
      ] }),
      /* @__PURE__ */ e(
        i,
        {
          className: "self-start group-hover:bg-primary group-hover:text-white center",
          size: "sm",
          variant: "glassy",
          icon: /* @__PURE__ */ e(c, { className: "rtl:rotate-180", name: "Chevron" }),
          iconPosition: "end",
          children: a
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: n("p-0 w-full", t), children: /* @__PURE__ */ e("img", { className: "w-full h-full object-cover", src: s, alt: l }) })
  ] }) });
}
export {
  p as ProductCard
};
//# sourceMappingURL=product-card.js.map
